module.exports = __webpack_public_path__ + "img/LF_KatS.cb6f4573.svg";